export default {
  path: '/condition',
  name: 'condition',
  component: () => import(/* webpackChunkName: "condition" */ './app.vue'),
  children: [
    {
      path: '',
      component: () => import(/* webpackChunkName: "condition" */ './views/index.vue'),
      meta: {
        title: '申请合作',
      },
    },
  ],
};
